export const SIMPLE = '__SIMPLE_API__';
export const NO_CONTENT = 204;
